<template>
    <VDialog v-model="visivel" scrollable>
        <Loading ref="loading"/>
        <VCard>
            <VCardTitle class="title">Bloqueios de horário</VCardTitle>
            <VCardText>
                <VForm ref="form">
                    <VLayout>
                        <VFlex>
                            <VSelect label="Profissional" item-text="nomeFantasia" item-value="id"
                                     v-model="formBloqueio.profissional" prepend-icon="person"
                                     :rules="[rules.obrigatorio()]"
                                     :items="profissionais" return-object></VSelect>
                        </VFlex>
                    </VLayout>
                    <VDivider></VDivider>
                    <VLayout>
                        <VFlex>
                            <VTextField label="Motivo" prepend-icon="comment"
                                        v-model="formBloqueio.motivo" :rules="[rules.obrigatorio()]"></VTextField>
                        </VFlex>
                    </VLayout>
                    <VLayout>
                        <VFlex md2>
                            <SelecaoData label="Início" v-model="formBloqueio.dataInicio"
                                         :rules="[rules.obrigatorio()]"></SelecaoData>
                        </VFlex>
                        <VFlex md2>
                            <SelecaoData label="Fim" v-model="formBloqueio.dataFim"
                                         :rules="[rules.obrigatorio()]"></SelecaoData>
                        </VFlex>
                        <VFlex md2>
                            <VCheckbox color="primary" label="Dia inteiro"
                                       v-model="formBloqueio.diaInteiro"></VCheckbox>
                        </VFlex>
                        <VFlex md3>
                            <VTextField prepend-icon="alarm" label="Hora de início"
                                        mask="##:##" return-masked-value
                                        v-model="formBloqueio.horaInicio"
                                        :disabled="formBloqueio.diaInteiro"
                                        ref="horaInicio"
                                        :rules="[rules.obrigatorio(!formBloqueio.diaInteiro), rules.hora]"></VTextField>
                        </VFlex>
                        <VFlex md3>
                            <VTextField prepend-icon="alarm" label="Hora de fim" mask="##:##"
                                        return-masked-value
                                        v-model="formBloqueio.horaFim"
                                        ref="horaFim"
                                        :disabled="formBloqueio.diaInteiro"
                                        :rules="[rules.obrigatorio(!formBloqueio.diaInteiro), rules.hora]"></VTextField>
                        </VFlex>
                    </VLayout>
                    <VLayout row justify-end>
                        <VBtn @click="limparFormulario">Limpar</VBtn>
                        <VBtn color="primary" @click="adicionarBloqueio">Adicionar</VBtn>
                    </VLayout>
                </VForm>
                <VContainer fluid v-if="formBloqueio.profissional" ma-0 pa-0>
                    <VCardTitle class="ma-0 pa-0 subheading">Bloqueios cadastrados para
                        {{formBloqueio.profissional.nomeFantasia}}
                    </VCardTitle>
                    <VDataTable :items="formBloqueio.profissional.excecoesDisponibilidade" :headers="cabecalhos"
                                :pagination.sync="paginacao" no-data-text="Nenhum bloqueio cadastrado">
                        <template v-slot:items="props">
                            <tr>
                                <td>{{props.item.motivo}}</td>
                                <td>{{formatarData(props.item.dataInicio, '-')}}</td>
                                <td>{{formatarData(props.item.dataFim, '-')}}</td>
                                <td>{{props.item.diaInteiro ? 'Sim' : 'Não'}}</td>
                                <td>{{formatarHora(props.item.horaInicio ? '1900-01-01T' + props.item.horaInicio : '')}}</td>
                                <td>{{formatarHora(props.item.horaFim ? '1900-01-01T' + props.item.horaFim : '')}}</td>
                                <td>
                                    <BotaoExcluir @click="excluir(props.item)"/>
                                </td>
                            </tr>
                        </template>
                    </VDataTable>
                </VContainer>
            </VCardText>
            <VCardActions>
                <VLayout justify-end row>
                    <VBtn @click="visivel = false">Fechar</VBtn>
                </VLayout>
            </VCardActions>
        </VCard>
    </VDialog>
</template>

<script>
    import SelecaoData from "../SelecaoData";
    import ApiService from '@/common/api.service';
    import forms from '@/common/forms';
    import datas from '@/mixins/datas';
    import BotaoExcluir from "../Botoes/BotaoExcluir";
    import Loading from "./Loading";
    import alerts from "../../common/alerts";
    import eventos from "../../common/eventos";

    export default {
        name: 'BloqueioHorarios',
        components: {SelecaoData, BotaoExcluir, Loading},
        props: {
            value: Boolean
        },
        mixins: [datas],
        methods: {
            async excluir(bloqueio) {
                try {
                    await this.atualizarProfissionais(ApiService.delete(`bloqueios/${bloqueio.id}`));
                } catch (e) {
                    alerts.exibirErro('Não foi possível remover o bloqueio', e);
                }
            },
            async atualizarProfissionais(promise) {
                [this.profissionais] = (await this.$refs.loading.aguardarPromises([promise])).map(r => r.data);
                this.formBloqueio.profissional = this.profissionais.filter(p => p.id === this.formBloqueio.profissional.id)[0];
                this.modificado = true;
            },
            async agendamentosNoBloqueio(f) {
                try {
                    let dtinicio = f.dataInicio + (f.diaInteiro ? " 00:00" : (" " + f.horaInicio));
                    let dtfim = f.dataFim + (f.diaInteiro ? " 23:59" : (" " + f.horaFim));
                    let agendamentos = await ApiService.get(`agenda/agendamentosprofissional/${f.profissional.id}/${dtinicio}/${dtfim}`);
                    if (agendamentos.data.length > 0){
                        return true;
                    } else {
                        return false;
                    }
                } catch (e) {
                    return false;
                }
            },
            async adicionarBloqueio() {
                if (this.$refs.form.validate()) {
                    let f = this.formBloqueio;
                    let existeAgendamentoPeriodo = await this.agendamentosNoBloqueio(f);
                    if (existeAgendamentoPeriodo){
                        if (
                            !(await alerts.pedirConfirmacao(
                            "Bloqueio de Agenda",
                            "Existem agendamentos para o profissional neste período. Deseja continuar?"
                            ))
                        ) {
                            return;
                        }
                    }
                    try {
                        await this.atualizarProfissionais(ApiService.post('bloqueios', {
                                idProfissional: f.profissional.id,
                                motivo: f.motivo,
                                dataInicio: f.dataInicio,
                                dataFim: f.dataFim,
                                diaInteiro: f.diaInteiro,
                                horaInicio: f.diaInteiro ? null : f.horaInicio,
                                horaFim: f.diaInteiro ? null : f.horaFim
                            }
                        ));
                        this.limparFormulario();
                    } catch (e) {
                        await alerts.exibirErro('Não foi possível cadastrar o bloqueio', e);
                    }
                }
            },
            limparFormulario() {
                this.formBloqueio.dataInicio = this.dataIso(new Date());
                this.formBloqueio.dataFim = this.formBloqueio.dataInicio;
                this.formBloqueio.diaInteiro = false;
                this.formBloqueio.horaInicio = null;
                this.formBloqueio.horaFim = null;
                this.formBloqueio.motivo = null;
                this.$refs.form.resetValidation();
            }
        },
        data() {
            return {
                rules: forms.rules,
                visivel: false,
                profissionais: [],
                formBloqueio: {
                    profissional: null,
                    motivo: null,
                    dataInicio: null,
                    dataFim: null,
                    horaInicio: null,
                    horaFim: null,
                    diaInteiro: false
                },
                cabecalhos: [
                    {
                        text: 'Motivo',
                        value: 'motivo',
                    },
                    {
                        text: 'Data início',
                        value: 'dataInicio'
                    },
                    {
                        text: 'Data fim',
                        value: 'dataFim'
                    },
                    {
                        text: 'Dia inteiro',
                        value: 'diaInteiro',
                        sortable: false
                    },
                    {
                        text: 'Hora início',
                        value: 'horaInicio'
                    },
                    {
                        text: 'Hora fim',
                        value: 'horaFim'
                    },
                    {
                        text: 'Ações',
                        value: 'id',
                        sortable: false
                    }
                ],
                paginacao: {
                    page: 1,
                    rowsPerPage: 5,
                    sortBy: 'dataInicio',
                    descending: true
                },
                modificado: false
            }
        },
        watch: {
            value(v) {
                this.visivel = v;
            },
            async visivel(v) {
                if (v) {
                    this.modificado = false;
                    this.limparFormulario();
                    try {
                        [this.profissionais] = (await this.$refs.loading.aguardarPromises([ApiService.get('bloqueios')])).map(r => r.data);
                    } catch (e){
                        await alerts.exibirErro('Erro ao carregar bloqueios de horário', e);
                        this.visivel = false;
                    }
                } else {
                    this.formBloqueio.profissional = null;
                    if (this.modificado) {
                        eventos.barramento.$emit(eventos.BLOQUEIOS_ATUALIZADOS);
                    }
                }
                if (this.value !== v) {
                    this.$emit('input', v);
                }
            }
        }
    }
</script>

<style scoped>

</style>
